import { render, staticRenderFns } from "./UserWidgets.vue?vue&type=template&id=68ff4c6d"
import script from "./UserWidgets.vue?vue&type=script&lang=js"
export * from "./UserWidgets.vue?vue&type=script&lang=js"
import style0 from "./UserWidgets.vue?vue&type=style&index=0&id=68ff4c6d&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports